import React from "react";
import styled from "styled-components";
import { Car } from "styled-icons/fa-solid";
import { Check } from "styled-icons/fa-solid";
import { PiggyBank } from "styled-icons/fa-solid";
import { Percent } from "styled-icons/remix-fill";
import { TimeFive } from "styled-icons/boxicons-solid";

import { Container } from "@components/global";

const FeaturesGdansk = () => (
  <Bg>
    <Container>
      <Wrapper>
        <Feature>
          <PiggyBank />
          <Desc>Brak kaucji</Desc>
        </Feature>
        <Feature>
          <Car />
          <Desc>Nowe auta z instalacją LPG</Desc>
        </Feature>
        <Feature>
          <Check />
          <Desc>Podstawienie za darmo</Desc>
        </Feature>
        <Feature>
          <Percent />
          <Desc>Rabaty dla stałych klientów</Desc>
        </Feature>
        <Feature>
          <TimeFive />
          <Desc>Infolinia 24/7</Desc>
        </Feature>
      </Wrapper>
    </Container>
  </Bg>
);

const Feature = styled.section`
  padding: 8px;
  position: relative;
  text-align: center;

  svg {
    width: 40px;
    height: 30px;
    display: block;
    margin: 0 auto;
    color: #fff;
  }
`;

const Desc = styled.p`
  display: block;
  margin: 5px 0;
  margin-bottom: 0;
  ${(props) => props.theme.font_size.small};
  color: #fff;
`;

const Bg = styled.div`
  box-shadow: 0 2px 16px 4px rgba(0, 0, 0, 0.16);
  z-index: 1;
  position: relative;
  background-color: ${(props) => props.theme.color.primary.regular};
`;

const Wrapper = styled.section`
  margin: 0;
  position: relative;
  @media (min-width: ${(props) => props.theme.screen.md}) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    justify-content: stretch;
    padding: 8px 0;
  }
`;
export default FeaturesGdansk;
